import { render, staticRenderFns } from "./DialogLegal.vue?vue&type=template&id=f68a31f8"
import script from "./DialogLegal.vue?vue&type=script&lang=js"
export * from "./DialogLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports